import * as THREE from "three";
import Material from "./Material"
import { defaultMaterial } from "../../utils/defaultMaterial";

export default class MaterialPair
{
    materialData: Material;
    threeJsMaterial: THREE.Material | undefined;
    // Variant for floor and ceiling coverings, whose texture direction follows the covering's local X axis
    threeJsHorizontalMaterial: THREE.Material | undefined;

    constructor(materialData: Material, threeJsMaterial : THREE.Material | undefined, threeJsHorizontalMaterial? : THREE.Material)
    {
        this.materialData = materialData;
        this.threeJsMaterial = threeJsMaterial;
        this.threeJsHorizontalMaterial = threeJsHorizontalMaterial;
    }

    getThreeJsMaterial(isHorizontalCovering = false) : THREE.Material {
        if (isHorizontalCovering && this.threeJsHorizontalMaterial)
            return this.threeJsHorizontalMaterial;

        return this.threeJsMaterial 
                ? this.threeJsMaterial 
                : defaultMaterial;
    }
}